import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Github, Linkedin, Mail } from 'lucide-react';

export default function AboutPage() {
  const { t } = useTranslation();
  return (
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white rounded-2xl shadow-sm p-8 md:p-12"
          >
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <img src="/profile.jpg" alt={t('pages.about.title')} className="w-32 h-32 md:w-48 md:h-48 rounded-full object-cover" />
              <div>
                <h1 className="text-3xl font-bold mb-6">{t('pages.about.title')}</h1>
                <div className="prose prose-lg max-w-none">
                  <p>{t('pages.about.p1')}</p>
                  <p>{t('pages.about.p2')}</p>
                  <p>{t('pages.about.p3')}</p>
                  <p>{t('pages.about.p4')}</p>
                </div>

                <div className="mt-8 flex gap-4">
                  <a
                      href="https://linkedin.com/in/leahgolub"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-600 hover:text-gray-900"
                  >
                    <Linkedin className="w-6 h-6" />
                  </a>
                  <a
                      href="mailto:koretigar@koretigar.com"
                      className="text-gray-600 hover:text-gray-900"
                  >
                    <Mail className="w-6 h-6" />
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
  );
}